import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import {Japanese} from "flatpickr/dist/l10n/ja.js";

const main = () => {
    const dateInputs = document.querySelectorAll('input[type="date"]');

    dateInputs.forEach(input => {
        // 2日後の日付を計算
        const minDate = new Date();
        minDate.setDate(minDate.getDate() + 1);

        flatpickr(input, {
            locale: Japanese,
            dateFormat: "Y-m-d",
            disableMobile: true,
            minDate: minDate,  // 2日後以降のみ選択可能
        });
    });
};

export default main;
